// extracted by mini-css-extract-plugin
module.exports = {"close":"GlobalPopupCross_close__3SsR7","closeOne":"GlobalPopupCross_closeOne__2nuA2","closeTwo":"GlobalPopupCross_closeTwo__sq_CU"};